import { TimelineMax, TweenMax, Expo } from 'gsap';

const pointerImage = (element) => {
  const image = element.querySelector('.pointer__image');
  const picture = element.querySelector('.pointer__image__picture');

  TweenMax.set(image, {
    scaleY: 0,
    rotation: 40,
    autoAlpha: 0,
    backgroundColor: '#A2A2A2',
  });
  TweenMax.set(picture, {
    clipPath: '50% 0% 50.001% 0.001%',
    webkitClipPath: '50% 0% 50.001% 0.001%',
  });

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .to(image, 0.8, {
      scaleY: 1,
      rotation: 0,
      autoAlpha: 0.7,
      ease: Expo.easeInOut,
    }, 'start')
    .to(picture, 0.8, {
      clipPath: '0% 0.001% 0.002% 0.003%',
      webkitClipPath: '0% 0.001% 0.002% 0.003%',
      ease: Expo.easeInOut,
    }, 'start+=0.1');

  return tl;
};

export default pointerImage;
